/**@jsx jsx */
import React, { useState } from 'react'
import { css, jsx } from '@emotion/core'
import { Tabs, Tab } from '@material-ui/core'
import AboutUs from './AboutUs';
import ContactUs from './ContactUs';

const TabsView = () => {

    const tabsContainer = css`
    * {
        font-family: Segoe UI;
    }
    color: #474747;
    background-color: #a9a9a91f;
    .PrivateTabIndicator-colorSecondary-3 {
        padding-bottom: 3px;
    }
    .MuiTab-root {
        font-size: inherit;
    }
    .MuiTabs-root {
        display: inline;
    }
    `;
    const [tabIndex, setTabIndex] = useState(0);

    const changeTab = (event, value) => {
        setTabIndex(value);
    }

    const switchTab = () => {
        switch (tabIndex) {
            case 0:
                return <AboutUs />
            case 1:
                return <ContactUs /> 
            default:
                return <AboutUs />
        }
    };

    return (
        <React.Fragment>
            <Tabs css={tabsContainer}
            TabIndicatorProps={{
                style: { background: "#4d86d7" }
            }}
            value={tabIndex} onChange={changeTab} variant="fullWidth">
            <Tab label="אודותינו" />
            <Tab label="צור קשר" />  
            </Tabs>
            {switchTab()}
        </React.Fragment>
    );
}

export default TabsView;